import {
	DirectionalLight,
	DirectionalLightHelper,
	CameraHelper,
	AmbientLight,
} from 'three';
import { ProductRenderer } from '../ProductRenderer';
import RENDERER_CONFIG from '@/configs/rendererConfig';

const { LIGHTS } = RENDERER_CONFIG;

export class LightController {
	directionalLight = new DirectionalLight(LIGHTS.COLOR, 0.6);
	ambientLight = new AmbientLight(LIGHTS.COLOR, 1);

	constructor(private renderer: ProductRenderer) {
		this.renderer = renderer;
		this.init();
	}

	private init() {
		if (this.renderer.isTouchDevice) {
			this.directionalLight.intensity = 4;
			this.renderer.scene.add(this.ambientLight);
		}

		this.directionalLight.position.set(0, LIGHTS.POS_Y, 50);

		this.renderer.scene.add(this.directionalLight);

		if (import.meta.env.DEV) {
			this.renderer.scene.add(
				new DirectionalLightHelper(this.directionalLight, 5, 0xff0000)
			);
			this.renderer.scene.add(
				new CameraHelper(this.directionalLight.shadow.camera)
			);
		}
	}
}
